"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Search_module_1 = tslib_1.__importDefault(require("./modules/Search.module"));
const loadMenuSearchModule = () => ({
    hasRouter: false,
    modules: [(0, Search_module_1.default)()],
});
exports.default = loadMenuSearchModule;
